<template>
  <v-container fluid grid-list-md>
    <p-share-form ref="PShareForm"></p-share-form>
    <v-layout wrap justify-center align-center>
      <v-flex xs12 lg4>
        <span class="headline">{{translate('table.forms.title')[1]}}</span>
      </v-flex>
      <v-flex xs12 sm6 lg4>
        <v-text-field append-icon="search" label="Pesquisar" v-model="search"></v-text-field>
      </v-flex>
      <v-flex xs12 sm6 lg4 class="text-xs-right">
        <p-btn-upgrade v-if="checkIsFree() && items.length >= 1"></p-btn-upgrade>
        <v-tooltip left>
          <v-btn slot="activator" color="primary" @click="processCreate" class="mb-4" :disabled="checkIsFree() && items.length >= 1">
            {{translate('system.button.add.title')}}
            <v-icon dark> {{translate('system.button.add.icon')}}</v-icon>
          </v-btn>
          <span>{{(checkIsFree() && items.length >= 1) ? 'Para incluir mais formulários faça o upgrade' : 'Adicionar formulário'}}</span>
        </v-tooltip>
      </v-flex>
      <!--Dialog para confirmação de exclusão-->
      <p-confirm text="Tem certeza que deseja excluir o item de " :entity="translate('table.' + entity + '.title')[1]" :dialog="dialogConfirm" @confirm="deleteItem" @cancel="closeDialogDelete"></p-confirm>
      <!--Index-->
      <v-flex xs12>
        <v-data-table
          :no-data-text="emptyTable"
          rows-per-page-text="Registros por página"
          :headers="headers"
          :items="items"
          :search="search"
          :rows-per-page-items="[10,20,30,{'text':'Todos','value':-1}]"
          class="elevation-1"
          :custom-filter="customizedFilter"  style="word-break: break-all;">
          <template slot="items" slot-scope="props">
            <td>{{ props.item.id_text }}</td>
            <td><a target="_blank" :href="link(props.item.id)">{{ link(props.item.id) }}</a></td>
            <td align="center" style="min-width: 110px">
              <v-btn icon class="mx-0" @click="viewItem(props.item.id)">
                <v-icon>visibility</v-icon>
              </v-btn>
              <v-btn icon class="mx-0" @click="processEditItem(props.item)">
                <v-icon color="teal">edit</v-icon>
              </v-btn>
              <v-btn icon class="mx-0" @click="dialogDelete(props.item)">
                <v-icon color="pink">delete</v-icon>
              </v-btn>
            </td>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
    <!--Create Edit-->
    <!-- // usado o v-if para sempre recarregar PFormCustomField -->
    <v-dialog v-model="dialog" v-if="dialog" max-width="600px" persistent scrollable>
      <!-- // formFields -->
      <v-card v-if="showFormFields">
        <v-card-title primary-title>
          <span class="headline">{{formTitle}}</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-form v-model="valid" @keyup.native.esc="close()" @keyup.native.ctrl.enter="saveProcess()" ref="form">
            <v-container grid-list-md>
              <v-layout wrap justify-center align-center>
                <v-flex xs12>
                  <div class="text-xs-center">
                    <v-avatar @click="$router.push(`/upgrade`)" size="150px" v-ripple v-if="checkIsFree()" class="grey lighten-3">
                      <span>Faça o upgrade para adicionar uma imagem!</span>
                    </v-avatar>
                    <p-upload-cropped-image v-else v-model="editedItem['logo_path']" @changeImage="changeImage">
                      <div slot="activator">
                        <v-avatar size="150px" v-ripple v-if="!editedItem['logo_path']" class="grey lighten-3">
                          <span>Clique para adicionar uma foto</span>
                        </v-avatar>
                        <v-avatar size="150px" v-ripple v-else>
                          <img :src="blobImage?editedItem['logo_path']:`${basePath}uploads/forms/${editedItem['logo_path']}`" alt="avatar">
                        </v-avatar>
                      </div>
                    </p-upload-cropped-image>
                  </div>
                </v-flex>
                <v-flex xs12>
                  <v-text-field :label="translate('table.' + entity + '.field.id_text')" v-model="editedItem.id_text" name="id_text" :rules="requiredRule(translate('table.' + entity + '.field.id_text'), 190)"></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-textarea :label="translate('table.' + entity + '.field.description')" v-model="editedItem.description" name="description"></v-textarea>
                </v-flex>
              </v-layout>
              <v-divider></v-divider>
              <p-form-custom-field ref="PFormCustomField" :form_id="editedItem['id']" :tasktemplate_id="tasktemplate_id" :formCustomFields="editedItem['form_custom_fields']"></p-form-custom-field>
            </v-container>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="mx-0" color="primary darken-2" :loading="loading" @click.native="proceed()">Prosseguir</v-btn>
          <v-btn class="mx-0" @click.native="close()">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
      <!-- // Mostra os campos da tarefa -->
      <v-card v-else>
        <v-card-title primary-title>
          <span class="headline">{{formTitle}}</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-form v-model="valid" @keyup.native.esc="close()" @keyup.native.ctrl.enter="saveProcess()" ref="form">
            <v-container grid-list-md>
              <v-layout wrap justify-center align-center>
                <v-flex xs12>
                  <v-combobox :value="editedItem['task_description']" @input="inputTaskDescription" :items="descriptionFormCustomField" item-text="custom_field.title" item-value="custom_field_id" label="Descrição da tarefa" chips clearable messages="Monte a descrição das tarefas que serão adicionadas por esse formulário." prepend-icon="filter_list" solo multiple :search-input.sync="searchTeste">
                    <template v-slot:selection="data">
                      <!-- // usado funções move e change pois so funcionou com elas, informações tiradas de https://stackoverflow.com/questions/63346033/add-drag-and-drop-to-vuetifys-select -->
                      <draggable :id="data.index" :list="editedItem['task_description']" v-bind="dragOptions" :move="moveDragTaskDescription" @change="changeDragTaskDescription">
                          <v-chip v-if="data.item['custom_field_id']" close @input="removeItemTaskDescription(data.item)" draggable :key="'s' + data.index" @mousedown.stop @click.stop>
                            <strong style="cursor: grab">{{ getItemTaskDescription(data.item['custom_field_id']) }}</strong>&nbsp;
                          </v-chip>
                          <v-chip v-else outline color="white" text-color="black" close @input="removeItemTaskDescription(data.item)" draggable :key="'s' + data.index" @mousedown.stop @click.stop>
                            <span style="cursor: grab">{{ data.item }}</span>&nbsp;
                          </v-chip>
                      </draggable>
                    </template>
                    <template v-slot:no-data>
                      <v-list-tile><v-list-tile-content><v-list-tile-title>
                            Pessione <kbd>enter</kbd> para adicionar o texto "<strong>{{ searchTeste }}</strong>".
                      </v-list-tile-title></v-list-tile-content></v-list-tile>
                    </template>
                  </v-combobox>
                </v-flex>
                <v-flex xs12 sm6>
                  <p-select-modal-editable id="begin_status_id" :label="translate('table.' + entity + '.field.begin_status_id')" v-model="editedItem['begin_status_id']" :selectedItem="editedItem['begin_status']" entity="task_status" :values="status_fields" placeholder="Não Iniciada" :companyId="editedItem['company_id']" @change="(id, item) => {editedItem['begin_status'] = item}" >
                    <v-container grid-list-md>
                      <v-layout wrap>
                        <v-flex xs2>
                          <v-tooltip bottom>
                            <swatches
                              slot="activator"
                              v-model="status_fields.color"
                              colors="material-basic"
                              row-length="4"
                              shapes="circles"
                              popover-to="right"
                              :swatch-style="{ margin: '5px 5px' }"
                              show-fallback
                            ></swatches>
                            <span>Alterar Cor</span>
                          </v-tooltip>
                        </v-flex>
                        <v-flex xs10>
                          <v-text-field id="modalfocus" v-model="status_fields.id_text" :label="translate('table.task_status.field.id_text')"></v-text-field>
                        </v-flex>
                        <v-switch label="Status de conclusão" :value=3 v-model="status_fields.identifier"></v-switch>
                      </v-layout>
                    </v-container>
                  </p-select-modal-editable>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field id="prevision" :label="translate('table.' + entity + '.field.prevision')" type="number" placeholder="Dias após a criação da tarefa" v-model="editedItem['prevision']"></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="mx-0" color="primary darken-2" :loading="loading" @click.native="saveProcess()">Salvar</v-btn>
          <v-btn class="mx-0" @click.native="showFormFields = true">Voltar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  /* eslint-disable eqeqeq */
  import crud from './../../mixin/crud'
  import rules from './../../mixin/rules'
  import plan from './../../mixin/plan'
  import PConfirm from './PConfirm'
  import PUploadCroppedImage from './PUploadCroppedImage'
  import PFormCustomField from './PFormCustomField'
  import PSelectModalEditable from './PSelectModalEditable'
  import PBtnUpgrade from './PBtnUpgrade'
  import PShareForm from './PShareForm'
  import draggable from 'vuedraggable'
  import Swatches from 'vue-swatches'

  export default {
    name: 'PForm',
    mixins: [crud, rules, plan],
    components: {PConfirm, PUploadCroppedImage, PFormCustomField, PSelectModalEditable, draggable, Swatches, PShareForm, PBtnUpgrade},
    props: {
      tasktemplate_id: {
        type: Number,
        default: 0
      }
    },
    data: () => ({
      search: '',
      basePath: process.env.API,
      image: '',
      showFormFields: true,
      blobImage: false,
      descriptionFormCustomField: [],
      entity: 'forms',
      searchTeste: '',
      status_fields: {id_text: '', active: true, color: '', identifier: null},
      dragOptions: { animation: 200, group: 'item-task-description', disabled: false },
      dragged: {
        from: -1,
        to: -1,
        newIndex: -1
      }
    }),
    created () {
      this.editedItem = {tasktemplate_id: this.tasktemplate_id, id_text: '', description: '', logo_path: '', form_custom_fields: [], task_description: '', begin_status_id: '', prevision: '', active: true}
      this.defaultItem = {tasktemplate_id: this.tasktemplate_id, id_text: '', description: '', logo_path: '', form_custom_fields: [], task_description: '', begin_status_id: '', prevision: '', active: true}

      this.$http.get(`api/${this.entity}?where=tasktemplate_id=${this.tasktemplate_id}`).then((res) => {
        this.items = res.body
        this.$emit('itemsLength', this.items.length)
      }, err => {
        console.log(err)
        this.$store.commit('snackbar/change_values', {text: 'Não foi possível incluir o registro de ' + this.translate('table.' + this.entity + '.title')[0] + ', reporte o erro.', color: 'error', dialog: true})
      })
    },
    methods: {
      processEditItem (item) {
        this.$store.commit('loader/change_dialog', true)
        this.showFormFields = true
        this.$http.get(`api/${this.entity}/${item['id']}`).then((res) => {
          this.$store.commit('loader/change_dialog', false)
          this.editItem(res.body)
        }, err => {
          console.log(err)
          this.$store.commit('snackbar/change_values', {text: 'Não foi possível buscar o registro de ' + this.translate('table.' + this.entity + '.title')[0] + ', reporte o erro.', color: 'error', dialog: true})
          this.$store.commit('loader/change_dialog', false)
        })
      },
      processCreate () {
        this.showFormFields = true
        this.create()
      },
      proceed () {
        if ((this.$refs.form && !this.$refs.form.validate())) {
          this.$store.commit('snackbar/change_values', {
            text: 'Por favor, corrija as validações antes de salvar!',
            color: 'warning',
            dialog: true
          })
          return false
        }
        this.showFormFields = false
        // Busca os campos selecionados no fomulários
        this.editedItem['form_custom_fields'] = this.$refs.PFormCustomField.items
        // Tira os campso de arquivo pois não é possivel adicionar campos de arquvio na descrição
        this.descriptionFormCustomField = this.editedItem['form_custom_fields'].filter((val) => { return val['custom_field']['type'] !== 'files' })
      },
      saveProcess () {
        if (this.image) {
          this.$store.commit('loader/change_dialog', true)
          this.$http.post('api/form/upload', this.image).then(res => {
            this.blobImage = false
            this.image = ''
            this.editedItem['logo_path'] = res.bodyText
            this.$store.commit('loader/change_dialog', false)
            this.save()
          },
          err => {
            console.log(err)
            this.$store.commit('loader/change_dialog', false)
          })
        } else {
          this.save()
        }
      },
      changeImage (val) {
        this.image = val
        this.blobImage = true
      },
      getItemTaskDescription (customFieldId) {
        let formCustomField = this.editedItem['form_custom_fields'].find((val) => { return val['custom_field_id'] == customFieldId })
        if (formCustomField) {
          return formCustomField['custom_field']['title']
        } else {
          return 'Registro não encontrado'
        }
      },
      link (formId) {
        return `https://${window.location.hostname}/#/form_view/${btoa(formId)}`
      },
      viewItem (formId) {
        this.$refs.PShareForm.openDialog(formId)
      },
      removeItemTaskDescription (item) {
        // caso tenha custom_field_id significa que o item é um campo caso contrario é apenas uma string
        if (item['custom_field_id']) {
          this.editedItem['task_description'] = this.editedItem['task_description'].filter((val) => { return val['custom_field_id'] !== item['custom_field_id'] })
        } else {
          this.editedItem['task_description'] = this.editedItem['task_description'].filter((val) => { return val !== item })
        }
      },
      inputTaskDescription (values) {
        // Pega o ultimo item inserido e verifica se ele é de um campo personalizado, caso seja diminui a quantidade de propriedades que tem nele para não ficar cheio de lixos
        let lastIndex = values.length - 1
        let item = values[lastIndex]
        if (item && item['custom_field_id']) {
          // No type, verifica se tem custom_field pois caso não tenha é pq o suuário tirouu algum item e deve apenas pegar o type do item
          values[lastIndex] = {custom_field_id: item['custom_field_id'], type: item['custom_field'] ? item['custom_field']['type'] : item['type']}
        }
        this.editedItem['task_description'] = values
      },
      moveDragTaskDescription (value) {
        this.dragged = {
          from: parseInt(value.from.id),
          to: parseInt(value.to.id),
          newIndex: value.draggedContext.futureIndex
        }
      },
      changeDragTaskDescription (value) {
        if (value.removed) {
          // insert
          this.editedItem['task_description'].splice(this.dragged.to + this.dragged.newIndex, 0, this.editedItem['task_description'][this.dragged.from])
          // delete
          this.dragged.from < this.dragged.to ? this.editedItem['task_description'].splice(this.dragged.from, 1) : this.editedItem['task_description'].splice(this.dragged.from + 1, 1)
        }
      }
    },
    computed: {
      headers: function () {
        return [
          {text: this.translate('table.' + this.entity + '.field.id_text'), value: 'id_text', width: '50%'},
          {text: 'Link', value: '', width: '30%'},
          {text: this.translate('system.table.action'), value: 'action', sortable: false, align: 'center'}
        ]
      }
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/shared/PForm.vue